import { render, staticRenderFns } from "./PageHeader.vue?vue&type=template&id=bb40dbf4&scoped=true"
import script from "./PageHeader.vue?vue&type=script&lang=ts"
export * from "./PageHeader.vue?vue&type=script&lang=ts"
import style0 from "./PageHeader.vue?vue&type=style&index=0&id=bb40dbf4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb40dbf4",
  null
  
)

export default component.exports